export interface CompanyData {
  website: string;
  industry: string;
  revenueModel: string;
  companySize: string;
  marketPosition: string;
}

interface CompanySectionProps {
  data: CompanyData;
  onChange: (data: CompanyData) => void;
}

/** Company step fields (website, uploads, and document extract live in QuestionnaireQuickStart). */
export function CompanySection({ data, onChange }: CompanySectionProps) {
  const update = (field: keyof CompanyData, value: string) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-5">
      <p className="text-sm text-gray-600">
        Use <strong className="text-gray-800">Quick start</strong> above to pull in your website,
        upload files, or extract from documents. Edit company details here.
      </p>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Industry / Sector</label>
        <input
          type="text"
          value={data.industry}
          onChange={(e) => update('industry', e.target.value)}
          placeholder="e.g., B2B SaaS, Fintech, Healthcare"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          How does your company make revenue?
        </label>
        <textarea
          value={data.revenueModel}
          onChange={(e) => update('revenueModel', e.target.value)}
          rows={3}
          placeholder="Describe your revenue model..."
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Company Size</label>
        <select
          value={data.companySize}
          onChange={(e) => update('companySize', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          <option value="">Select size</option>
          <option value="1-10">1-10 employees</option>
          <option value="11-50">11-50 employees</option>
          <option value="51-200">51-200 employees</option>
          <option value="201-500">201-500 employees</option>
          <option value="500+">500+ employees</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Market Position</label>
        <select
          value={data.marketPosition}
          onChange={(e) => update('marketPosition', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          <option value="">Select position</option>
          <option value="Leader">Leader</option>
          <option value="Challenger">Challenger</option>
          <option value="Niche">Niche</option>
          <option value="Emerging">Emerging</option>
        </select>
      </div>
    </div>
  );
}
